import React from "react";
import Events from "../../../../utilities/EventEmitter";
import getDataWithAbort from "../../../../api/getDataWithAbort";
import appConstants from "../../../../appConstants";

export function withTrailerHOC(Component) {
  return class TrailerData extends React.Component {
    constructor(props) {
      super(props);
      this.state = {
        trailerList: null,
        message: appConstants.GRID_STATUS.LOADING,
      };
      this._isMounted = false;
      this.getTrailerData();
    }
    componentDidMount() {
      this._isMounted = true;
      Events.on("RefreshTrailersData", this.getTrailerData);      
    }

    getTrailerData = () => {
      getDataWithAbort(
        "TrailersList",
        `terminalCode=${this.props.userData.userProfile.terminal.code}`
      )
        .then((response) => {
          if (!this._isMounted) {
            return;
          }
          if (response && response.status === 200) {
            this.setState({
              trailerList: response.data ?? [],
              message: appConstants.GRID_STATUS.SUCCESS,
            });
          } else {
            this.setState({
              trailerList: [],
              message: appConstants.GRID_STATUS.ERROR,
            });
          }
        })
        .catch(() => {});
    };

    componentWillUnmount() {
      this._isMounted = false;
      Events.off("RefreshTrailersData", this.getTrailerData);
    }
    render() {
      return (
        <Component
          {...this.props}
          trailerList={this.state.trailerList}
          trailerDataMessage={this.state.message}
        />
      );
    }
  };
}
